import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ComingSoon: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + 15); // Set target to 15 days from now

        const interval = setInterval(() => {
            const now = new Date();
            const difference = targetDate.getTime() - now.getTime();

            if (difference <= 0) {
                clearInterval(interval);
            } else {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / 1000 / 60) % 60);
                const seconds = Math.floor((difference / 1000) % 60);

                setTimeLeft({ days, hours, minutes, seconds });
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            {/* center wrap */}
            <div className="coverimg h-100 w-100 top-0 start-0 position-absolute z-index-0 opacity-50">
                <img src={asset('assets/img/adminuiux/image-3.jpg')} alt="" />
            </div>
            <div className="row justify-content-center align-items-center vh-100 position-relative z-index-1">
                <div className="col-11 col-sm-8 col-lg-6 col-xxl-5 maxwidth-dynamic" style={{ '--mw-dynamic': '600px' } as React.CSSProperties}>
                    <div className="card adminuiux-card my-3 my-lg-4">
                        <div className="card-body py-4 py-lg-5">
                            <div className="mb-4 mb-lg-5 text-center">
                                <h1>We're coming soon...</h1>
                                <h4 className="">We are at the edge of our final release.</h4>
                            </div>
                            <div className="row gx-4 gx-lg-5 align-items-center justify-content-center text-center">
                                <div className="col col-md-auto">
                                    <span id="days" className="fw-bold h1">{timeLeft.days}</span><br />
                                    <small className="opacity-50">Days</small>
                                </div>
                                <div className="col col-md-auto">
                                    <span id="hrs" className="fw-bold h1">{timeLeft.hours}</span><br />
                                    <small className="opacity-50">Hours</small>
                                </div>
                                <div className="col col-md-auto">
                                    <span id="min" className="fw-bold h1">{timeLeft.minutes}</span><br />
                                    <small className="opacity-50">Min</small>
                                </div>
                                <div className="col col-md-auto">
                                    <span id="sec" className="fw-bold h1">{timeLeft.seconds}</span><br />
                                    <small className="opacity-50">Sec</small>
                                </div>
                            </div>

                            <p id="endtimer" className="mt-4 mt-lg-5"></p>

                            {/* subscription */}
                            <div className="input-group maxwidth-300 mb-3 mx-auto">
                                <input type="text" className="form-control text-white" placeholder="Your email address" />
                                <button className="btn btn-theme" type="button">Subscribe</button>
                            </div>
                            <h5 className="mb-1 text-center">Subscribe for our newsletter</h5>
                            <p className="text-secondary text-center mb-lg-4">You will get an email with steps and verification.</p>

                        </div>
                    </div>
                    {/* social links */}
                    <div className="text-center mb-3 mb-lg-4">
                        <Link to="/app/dashboard" className="btn btn-square btn-link rounded-circle" data-toggle="tooltip" title="Dashboard"><i className="bi bi-arrow-left"></i></Link>
                        <a className="btn btn-square btn-link rounded-circle" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a>
                        <a className="btn btn-square btn-link rounded-circle" target="_blank" rel="noreferrer"><i className="bi bi-twitter"></i></a>
                        <a className="btn btn-square btn-link rounded-circle" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a>
                        <a className="btn btn-square btn-link rounded-circle" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ComingSoon;
